import React, { useContext } from "react";
import { TouchableOpacity, StyleSheet } from "react-native";
import { useSelector } from "react-redux";

import { Text } from "../../../../components/shared/Themed";
import { Switch as RNSwitch } from "react-native-switch";
import { ReadOnlyProps } from "../../../../utils/templates";
import DeviceOrientationContext from "../../../../components/context/DeviceOrientationContext";
import { useTranslation } from "../../../../utils/useTranslation";

interface Props {
  title?: string;
  lastRefresh?: string;
  isDisplayViewOn: boolean;
  setIsDisplayViewOn: (hasDisplay: boolean) => void;
}

export const StockReportDisplaySwitch: React.FC<Props> = (
  props: ReadOnlyProps<Props>
) => {
  const { isSmallDevice, isMobileDevice } = useContext(DeviceOrientationContext);
  const isMobile = isSmallDevice || isMobileDevice;
  const { t } = useTranslation();
  const { language } = useSelector((state: any) => state.configurations);
  const isZh = language === "zh";

  return (
    <>
      {props.lastRefresh && (
        <>
          <Text style={[styles.lastRefresh, isMobile && { fontSize: 10, marginLeft: 4, marginRight: 4 }]}>
            {t("lastRefresh")}:{" "}
            <Text style={{ fontWeight: "normal" }}> {props.lastRefresh}</Text>
          </Text>{" "}
          <Text style={isMobile && { fontSize: 10 }}>&nbsp;|&nbsp;</Text>
        </>
      )}

      <Text style={[styles.title, isMobile && { fontSize: 13, marginLeft: 4, marginRight: 4 }]}>{props.title}</Text>
      <TouchableOpacity>
        <RNSwitch
          value={props.isDisplayViewOn}
          onValueChange={props.setIsDisplayViewOn}
          disabled={false}
          activeText={t("carton")}
          inActiveText={t("piece")}
          circleSize={isMobile ? 20 : 25}
          barHeight={isMobile ? 24 : 30}
          circleBorderWidth={2}
          //Active Props
          backgroundActive={"rgb(47, 149, 220)"}
          circleActiveColor={"#8BCAE5"}
          //InActive Props
          backgroundInactive={"rgba(0, 0, 0, 0.12)"}
          circleInActiveColor={"#A3A4A2"}
          inactiveTextStyle={{ color: "black", fontSize: isMobile ? 10 : 12 }}
          activeTextStyle={{ color: "white", fontSize: isMobile ? 10 : 12 }}
          circleBorderInactiveColor="#858683"
          renderInActiveText={true}
          //renderInsideCircle={() => <CustomComponent />} // custom component to render inside the Switch circle (Text, Image, etc.)
          changeValueImmediately={true} // if rendering inside circle, change state immediately or wait for animation to complete
          innerCircleStyle={{
            alignItems: "center",
            justifyContent: "center",
          }} // style for inner animated circle for what you (may) be rendering inside the circle
          renderActiveText={true}
          switchLeftPx={2} // denominator for logic when sliding to TRUE position. Higher number = more space from RIGHT of the circle to END of the slider
          switchRightPx={2} // denominator for logic when sliding to FALSE position. Higher number = more space from LEFT of the circle to BEGINNING of the slider
          switchWidthMultiplier={props.isDisplayViewOn
            ? (isMobile ? (isZh ? 2.8 : 4.3) : (isZh ? 3.0 : 4.65))
            : (isMobile ? (isZh ? 2.4 : 3.6) : (isZh ? 2.6 : 3.85))} // multiplied by the `circleSize` prop to calculate total width of the Switch
          switchBorderRadius={30} // Sets the border Radius of the switch slider. If unset, it remains the circleSize.
          containerStyle={{ marginRight: 10 }}
        />
      </TouchableOpacity>
    </>
  );
};

const styles = StyleSheet.create({
  title: {
    marginLeft: 10,
    fontSize: 14,
    fontWeight: "bold",
    marginRight: 5,
  },
  lastRefresh: {
    marginLeft: 10,
    fontSize: 14,
    fontWeight: "bold",
    marginRight: 10,
    fontStyle: "italic",
  },
});
